import * as React from "react";
import { forwardRef } from "react";
const SvgCgBorderStyleDashed = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M4 11H8V13H4V11Z", fill: "currentColor" }), /* @__PURE__ */ React.createElement("path", { d: "M10 11H14V13H10V11Z", fill: "currentColor" }), /* @__PURE__ */ React.createElement("path", { d: "M20 11H16V13H20V11Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgCgBorderStyleDashed);
export default ForwardRef;
